import { render, staticRenderFns } from "./ShortCutComponent.vue?vue&type=template&id=3f883a92&scoped=true&"
import script from "./ShortCutComponent.vue?vue&type=script&lang=js&"
export * from "./ShortCutComponent.vue?vue&type=script&lang=js&"
import style0 from "./ShortCutComponent.vue?vue&type=style&index=0&id=3f883a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f883a92",
  null
  
)

export default component.exports